import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import "./components/react-accordion.css";
import { CheckToken, RefreshToken } from "../login/AccessToken";
import axios from "axios";
import { Card, Typography, Grid, CardContent, Box } from "@mui/material";
import { adminArr, adminAccessMapping } from "./constants";
import { toast } from "react-toastify";
import HTMateIcon from "../../assets/images/gallery/B-T-HTMATE.svg";
import HTBridgeIcon from "../../assets/images/gallery/B-T-BRIDGE.svg";
import HTHrpIcon from "../../assets/images/gallery/B-T-HTHRP.svg";

const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

function HlthtekAdminDemo({ setBrandingData }) {
  const history = useHistory();

  const [user, setUser] = useState("");
  const [refreshList, setRefreshList] = useState("");
  const [partnerName, setPartnerName] = useState(null);
  const [customerName, setCustomerName] = useState(null);
  const [facilityName, setFacilityName] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [roleType, setRoleType] = useState(
    sessionStorage.getItem("roleType") || ""
  );

  const allowedRoles = ["facility admin", "customer admin"];

  const fetchBrandingData = () => {
    const payload = {
      // functionality: "branding",
      // segment: "images",
      // config_type:"configuration",
      bucket_type: "license",
      bucket_category: "conf",
      file_key: "",
      // facility_id / client_name are optional; the backend resolves them
      // from the logged-in user when absent.
      ...(sessionStorage.getItem("facility_name")
        ? { facility_id: sessionStorage.getItem("facility_name") }
        : {}),
      ...(sessionStorage.getItem("customer_name")
        ? { client_name: sessionStorage.getItem("customer_name") }
        : {}),
    };

    axios
      .post(`${REACT_APP_BACKEND_ROUTE_URL}get_facility_branding/`, payload, {
        headers,
      })
      .then((res) => {
        if (res.data.status === "Success") {
          setBrandingData(res.data?.data);
          console.log("branding..demo", res.data?.data);
        } else if (res?.data?.message === "No files found.") {
          toast.info("Branding information not yet provided");
        } else {
          // toast.error("Error fetching branding data");
          console.log("Error:", res.data.message);
        }
      })
      .catch((err) => {
        console.log("Error fetching branding data:", err);
        toast.error("Error fetching branding data");
      });
  };

  useEffect(() => {
    if (authToken && roleType && allowedRoles.includes(roleType)) {
      fetchBrandingData();
    }
  }, []);
  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    const roleType = sessionStorage.getItem("roleType");
    console.log("admin page", accessToken, roleType);

    // if (
    //   !accessToken ||
    //   (roleType !== "admin" &&
    //     roleType !== "customer admin" &&
    //     roleType !== "partner admin" &&
    //     roleType !== "facility admin")
    // ) {
    //   history.push("/login");
    // }
  }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  useEffect(() => {
    const fetchUserInfo = async () => {
      const roleType = sessionStorage.getItem("roleType");

      if (authToken) {
        try {
          const response = await axios.get(
            `${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`,
            { headers: headers }
          );

          if (roleType === "customer admin") {
            sessionStorage.setItem(
              "customer_name",
              response.data.customer_name
            );
            sessionStorage.setItem("customer_id", response.data.customer_id);
            sessionStorage.setItem("partner_name", response.data.partner_name);

            setCustomerName(response.data.customer_name);
          } else if (roleType === "partner admin") {
            sessionStorage.setItem("partner_name", response.data.partner_name);
            sessionStorage.setItem("partner_id", response.data.partner_id);

            setPartnerName(response.data.partner_name);
          } else if (roleType === "facility admin") {
            setFacilityName(response.data.facility_name);
            sessionStorage.setItem(
              "facility_display_name",
              response.data.facility_name
            );
            // sessionStorage.setItem(
            //   "subscription_type",
            //   response.data.subscription_type
            // );
          }

          // Call filterMenuItems only after fetching user info
          filterMenuItems();
          setDataLoaded(true);
        } catch (error) {
          console.error("Error fetching user info:", error);
        }
      }
    };

    const filterMenuItems = () => {
      const roleType = sessionStorage.getItem("roleType");
      let allowedPaths;

      if (roleType === "facility admin") {
        allowedPaths =
          adminAccessMapping[roleType]?.[
            sessionStorage.getItem("subscriptionType")
          ] || [];
      } else {
        allowedPaths = adminAccessMapping[roleType];
      }

      const items = adminArr.filter((item) => allowedPaths.includes(item.id));
      setFilteredItems(items);
      console.log("Allowed Paths", allowedPaths);
      console.log("Items", items);
    };

    fetchUserInfo();
  }, []);

  const updateList = () => {
    setRefreshList(true);
  };

  const navigate = (route) => {
    history.push(`/${route}`);
  };

  const renderRoleTitle = () => {
    let roleType = sessionStorage.getItem("roleType");
    switch (roleType) {
      case "admin":
        return "Hlthtek";
      case "customer admin":
        return customerName;
      case "partner admin":
        return partnerName;
      case "facility admin":
        return facilityName;
      default:
        return null;
    }
  };
  return (
    <>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <Typography variant="h3" textAlign="center">
            {renderRoleTitle()}
          </Typography>
        </Grid>
        {roleType === "facility admin" && (
          <Grid
            item
            xs={4}
            container
            direction="column"
            justifyContent="left"
            // spacing={3}
            alignItems="center"
            sx={{ paddingLeft: { xs: "0.5rem", sm: "1rem" } }} // Adjust padding for responsiveness
          >
            <Grid item>
              <Box
                component="img"
                src={
                  sessionStorage.getItem("subscriptionType") ===
                    "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                  sessionStorage.getItem("subscriptionType") ===
                    "EHR/HMIS Service Without ABDM Connector"
                    ? HTMateIcon
                    : sessionStorage.getItem("subscriptionType") ===
                        "ABDM Connector/Adaptor - HIU/HIP" ||
                      sessionStorage.getItem("subscriptionType") ===
                        "ABDM Connector/Adaptor - HIU" ||
                      sessionStorage.getItem("subscriptionType") ===
                        "ABDM Connector/Adaptor - HIP"
                    ? HTBridgeIcon
                    : HTHrpIcon
                }
                alt="HT Mate Icon"
                sx={{
                  borderRadius: "5px",
                  // width: { xs: 50, sm: 60, md: 80, lg: 100 }, // Responsive width
                  height: { xs: 50, sm: 60, md: 80, lg: 100 }, // Responsive height
                  width: { xs: 150, sm: 210, md: 255, lg: 300 }, // Responsive width
                }}
              />
            </Grid>

            {/* <Grid item>
              <Typography variant="body1" fontSize="1rem" color="black">
                <b>
                  {sessionStorage.getItem("subscriptionType") ===
                    "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                  sessionStorage.getItem("subscriptionType") ===
                    "EHR/HMIS Service Without ABDM Connector"
                    ? "HTMATE"
                    : sessionStorage.getItem("subscriptionType") ===
                        "ABDM Connector/Adaptor - HIU/HIP" ||
                      sessionStorage.getItem("subscriptionType") ===
                        "ABDM Connector/Adaptor - HIU" ||
                      sessionStorage.getItem("subscriptionType") ===
                        "ABDM Connector/Adaptor - HIP"
                    ? "HTBRIDGE"
                    : "HTHRP"}
                </b>
              </Typography>
            </Grid> */}
          </Grid>
        )}
        <Grid
          direction="column"
          xs={roleType == "facility admin" ? 8 : 12}
          container
          justifyContent="flex-end"
          alignItems="flex-end"
          sx={{ paddingRight: { xs: "1rem", sm: "2rem" } }}
        >
          {/* <Grid item xs={12}>
            <Typography variant="body1" fontSize="1rem" color="black">
              <b>Name: {sessionStorage.getItem("name")}</b>
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" fontSize="1rem" color="black">
              <b>Logged in Role : {sessionStorage.getItem("roleType")}</b>
            </Typography>
          </Grid> */}
        </Grid>
      </Grid>
      {dataLoaded && filteredItems.length > 0 ? (
        <Grid
          container
          spacing={3}
          sx={{
            p: { xs: 1, sm: 2, md: 3 }, // Responsive padding left/right
            width: "80%",
            margin: "20px auto",
            justifyContent: "center", // Center the grid container
            boxShadow: 3, // Add a shadow for card styling
            borderRadius: 2, // Rounded corners
          }}
        >
          {filteredItems.map((item) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              key={item.id}
              onClick={() => navigate(item.path)}
              sx={{
                padding: "24px",
                cursor: "pointer", // Cursor pointer for click action
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  height: { xs: "170px", sm: "180px" }, // Set a fixed height for uniformity
                  display: "flex",
                  justifyContent: "center",
                  boxShadow: 3, // Add a shadow for card styling
                  borderRadius: 2, // Rounded corners
                  transition: "transform 0.3s ease", // Smooth hover effect
                  backgroundColor: "#21cdc0",
                  padding: 2,
                  "&:hover": {
                    transform: "scale(1.05)",
                    backgroundColor: "#003366", // Slight zoom on hover
                  },
                }}
              >
                <CardContent
                  sx={{
                    textAlign: "center", // Center the content inside the card
                  }}
                >
                  <div
                    style={{
                      marginBottom: "2rem",
                    }}
                  >
                    {item.icon}
                  </div>

                  <Typography
                    variant="h6"
                    sx={{ color: "white", textAlign: "center" }}
                  >
                    {item.name}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography variant="h3" textAlign="center">
          No Entitlement
        </Typography>
      )}
    </>
  );
}

export default HlthtekAdminDemo;
